export const ENTRY_EXISTS_GUID = '7fab0f358b504243be0c14d317806ff5';
